<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M16.2071 5.20711C16.5977 4.81658 16.5977 4.18342 16.2071 3.79289C15.8166 3.40237 15.1834 3.40237 14.7929 3.79289L7.08582 11.5L14.7929 19.2071C15.1834 19.5976 15.8166 19.5976 16.2071 19.2071C16.5977 18.8166 16.5977 18.1834 16.2071 17.7929L9.91424 11.5L16.2071 5.20711Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
